import { ModelBase, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class DestinationTableLookup extends ModelBase {
    public destinationTableId: number = 0;

    public destinationTableName: string = "";
}